import { useEffect, useState, type ComponentType } from 'react'

import type { PricingData } from '@/utils/pricing.server'

export default function PricingCalculatorIsland({ data }: { data: PricingData }) {
  const [Calculator, setCalculator] = useState<ComponentType<{ data: PricingData }> | null>(null)

  useEffect(() => {
    let cancelled = false

    void import('@/components/PricingCalculator').then((mod) => {
      if (!cancelled) {
        setCalculator(() => mod.default)
      }
    })

    return () => {
      cancelled = true
    }
  }, [])

  if (!Calculator) {
    return <div aria-busy='true' className='min-h-[40rem] min-w-0 flex-1 border' />
  }

  return <Calculator data={data} />
}
